export enum MatchScoreCapabilityTypes {
    capability = 'CAPABILITY',
    geography = 'GEOGRAPHY',
    industry = 'INDUSTRY',
    demographic = 'DEMOGRAPHIC',
    enterprise = 'ENTERPRISE',
  }
  